<iframe class="multimedia-viewer-container" [height]="_iframeHeight" [src]="safeFileUrl()"></iframe>
